export default __webpack_public_path__ + "static/media/logo.03cd3cf4.jpeg";